<template>
    <div class="profile-popover">
        <div class="nav-dropdown">
            <ul :class="{ disabled: loggedout }">
                <li @click="mainMain = false">
                    <a
                        v-b-modal.update-profile-popup
                        href="javascript:void(0);"
                    >
                        <i class="icon-person"></i>
                        <span>Update Profile</span>
                    </a>
                </li>
                <li @click="mainMain = false">
                    <a
                        v-b-modal.change-password-popup
                        href="javascript:void(0);"
                    >
                        <i class="icon-change-password"></i>
                        <span>Change Password</span>
                    </a>
                </li>
                <li @click="onBilling()" v-if="country!='Pakistan'">
                    <a href="javascript:;">
                        <i class="icon-account_balance"></i>
                        <span>Billing & Accounts</span>
                    </a>
                </li>
                <li @click="onLogout()">
                    <a href="javascript:;">
                        <i class="icon-sign-out"></i>
                        <span>Sign Out</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { directive as onClickOutside } from 'vue-on-click-outside'
export default {
    components: {},
    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPopover: false,
            mainMain: false,
            image: 'profile-pic.png',
            loggedout: false,
            country : process.env.VUE_APP_COUNTRY,

        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */

    computed: {
        ...mapGetters(['user']),
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    watch: {
        loggedout(value) {
            this.loggedout = value
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        open() {
            this.showPopover = true
        },
        close() {
            this.showPopover = false
        },
        async onLogout() {
            try {
                // onLogout action in auth store
                await this.$store.dispatch('authLogout')
                this.loggedout = true
            } catch (error) {
                console.log(error)
            }
        },
        async onBilling() {
            try {
                // onLogout action in auth store
                await this.$store.dispatch(
                    'stripeCustomerPortalRedirect',
                    this.user
                )
            } catch (error) {
                console.log(error)
            }
        },
    },
} // End of export default
</script>
